import { Ref, ref, watch } from 'vue';

export const useDebounce = (value: Ref<string>, delay = 250): Ref<string> => {
  const debouncedValue = ref(value.value);
  const timeoutId = ref<number>();

  watch(value, (newValue: string) => {
    clearTimeout(timeoutId.value);

    timeoutId.value = window.setTimeout(() => debouncedValue.value = newValue, delay);
  });

  return debouncedValue;
};
